import { Info } from "@tamagui/lucide-icons";
import { action, makeObservable } from "mobx";
import type { Api } from "../../../core/apis";
import type { Stores } from "../../../core/stores";
import BusinessModuleModel, {
  type BusinessModuleData,
  type BusinessModuleModelData,
  type Snapshot,
} from "../BusinessModuleModel";
import type { BusinessModuleType } from "../types";
import {
  BusinessInfoModuleBlockUI,
  BusinessInfoModuleFeedItemUI,
  BusinessInfoModuleUI,
} from "./BusinessInfoModuleUI";

// Nothing extra saved for now
export type BusinessInfoModuleSnapshot = Snapshot;

// Nothing extra saved for now
export type BusinessInfoData = BusinessModuleData & {
  type: BusinessModuleType.Info;
};
export interface BusinessInfoModuleModelData
  extends BusinessModuleModelData<BusinessInfoModuleSnapshot> {}

export default class BusinessInfoModuleModel extends BusinessModuleModel<
  BusinessInfoModuleSnapshot,
  BusinessInfoModuleModelData
> {
  hasDoneFlow = false;

  constructor(stores: Stores, api: Api, data: BusinessInfoModuleModelData) {
    super(stores, api, data);

    makeObservable(this);
  }

  @action async updateSnapshotWithoutSave() {
    // Saved in description field editor
  }

  toFireStore(): Omit<BusinessInfoModuleModelData, "uid"> {
    return {
      ...super.toFireStore(),
    };
  }

  render() {
    return <BusinessInfoModuleUI businessModule={this} />;
  }

  renderBlock() {
    return <BusinessInfoModuleBlockUI businessModule={this} />;
  }

  renderFeedItem() {
    return <BusinessInfoModuleFeedItemUI businessModule={this} />;
  }

  renderIcon(size?: number) {
    return <Info size={size} />;
  }
}
